
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M17.72 6.96a.75.75 0 00-1.28-.53l-5.36 4a1.75 1.75 0 102.38 2.4l4.04-5.34a.75.75 0 00.22-.53z"}}),_c('path',{attrs:{"d":"M12 0a12 12 0 1012 12A12.01 12.01 0 0012 0zm0 23a11 11 0 1111-11 11.01 11.01 0 01-11 11z"}}),_c('path',{attrs:{"d":"M17.88 8.16a.5.5 0 00-.2.68 6.5 6.5 0 01-1.15 7.73.5.5 0 10.7.7 7.5 7.5 0 001.32-8.91.5.5 0 00-.67-.2zM5.46 11.94a6.5 6.5 0 019.64-5.7.5.5 0 10.48-.88 7.5 7.5 0 00-11.12 6.58 7.44 7.44 0 002.24 5.33.5.5 0 10.7-.7 6.45 6.45 0 01-1.94-4.63z"}})])
          )
        }
      }
    